<div *ngIf="prikaziStranicu" class="container-fluid">
  <h2 class="content-block">DOSTAVNICE</h2>

  <dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)" [(visible)]="loadingVisible" [showIndicator]="true"
    [showPane]="true" [shading]="true" [closeOnOutsideClick]="false">
  </dx-load-panel>

  <div class="content-block dnevniPlanWrapper">
    <div class="selectDates">
      <div class="odabirDatuma">
        <label>Datum od:</label>
        <dx-date-box [(value)]="datumOd" [(max)]="datumDo" pickerType="calendar" displayFormat='dd.MM.yyyy.' width="200"
          (onValueChanged)="onValueChangedDatumOd($event)">
        </dx-date-box>
      </div>

      <div class="odabirDatuma">
        <label>Datum do:</label>
        <dx-date-box [(value)]="datumDo" [(min)]="datumOd" pickerType="calendar" displayFormat='dd.MM.yyyy.' width="200"
          (onValueChanged)="onValueChangedDatumDo($event)">
        </dx-date-box>
      </div>

      <div class="odabirDatuma">
        <dx-button class="btn_trazi" [disabled]="disableGumb" stylingMode="contained" text="Prikaži" type="success"
          [width]="120" (onClick)="pretrazi()">
        </dx-button>
      </div>
    </div>

    <!-- "problem" pravilo to što plus button bude iza Pretraži... (zbog direction: rtl;) pa je dodana klasa pregledDostavnica u style.css -->
    <div class="customTable pregledDostavnica">
      <dx-data-grid id="tablicaDostavnica" [dataSource]="dostavnice" [wordWrapEnabled]="true" noDataText="{{ poruka }}"
        keyExpr="pz_id" [showBorders]="false" [showColumnLines]="true" [columnAutoWidth]="true" [columnMinWidth]="60"
        (onToolbarPreparing)="onToolbarPreparing($event)" (onSelectionChanged)="onSelectionChanged($event)"
        (onRowClick)="onRowClick($event)" (onRowInserted)="dodajDostavnicu($event)"
        (onRowUpdated)="urediZaglavlje($event)" (onRowRemoved)="obrisiDostavnicu($event)"
        (onCellPrepared)="onCellPrepared($event)" (onInitNewRow)="onInitNewRow($event)"
        (onEditingStart)="onEditingStart($event)">
        <div *dxTemplate="let data of 'naslovTablice'" class="grid-wrapper">
          <div class="naslov">
            <h2 class="mb-0">Dostavnice</h2>
            <p class="mt-0">Kliknite na dostavnicu za prikaz detalja</p>
          </div>
        </div>

        <dxo-header-filter [visible]="true"></dxo-header-filter>

        <dxo-scrolling columnRenderingMode="virtual" [showScrollbar]="'always'"></dxo-scrolling>

        <dxo-search-panel [visible]="true" [width]="210" placeholder="Pretraži...">
        </dxo-search-panel>

        <dxo-export [enabled]="dozvoli_export" fileName="dostavnice"></dxo-export>

        <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>

        <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[10, 20, 30]" [showInfo]="true">
        </dxo-pager>

        <dxo-selection mode="single"></dxo-selection>

        <dxo-editing mode="popup" [allowAdding]="true" [allowUpdating]="true" [allowDeleting]="true">

          <dxo-popup [onShowing]="onShowing" [disabled]="pravaZaTrenutniPogled != 2" [showTitle]="true" title=""
            [maxWidth]="500" [height]="'auto'">
          </dxo-popup>

          <dxo-form [colCount]="1">
            <dxi-item dataField="pz_datum">
              <dxi-validation-rule type="required"></dxi-validation-rule>
            </dxi-item>

            <dxi-item dataField="poslovnica_po_id" editorType="dxSelectBox" [editorOptions]="{
                items: poslovnicePekar,
                value: 'idposlovnica',
                valueExpr: 'idposlovnica',
                displayExpr: 'sifrainaziv',
                searchEnabled: 'true',
                searchExpr: ['po_sifra', 'po_naziv']
              }">
              <dxi-validation-rule type="required"></dxi-validation-rule>
            </dxi-item>

            <dxi-item dataField="poslovnicapartnera_pp_id" editorType="dxSelectBox" [editorOptions]="{
                items: poslovniceTomo,
                value: 'pp_id',
                valueExpr: 'pp_id',
                displayExpr: 'sifrainaziv',
                searchEnabled: 'true',
                searchExpr: ['pp_sifra', 'pp_naziv']
              }">
              <dxi-validation-rule type="required"></dxi-validation-rule>
            </dxi-item>

            <dxi-item dataField="partner_pa_id_kupac" editorType="dxSelectBox" [editorOptions]="{
                items: partneri,
                value: 'pa_id',
                valueExpr: 'pa_id',
                displayExpr: 'sifrainaziv',
                searchEnabled: 'true',
                searchExpr: ['pa_sifra', 'pa_naziv'],
                onItemClick: partnerOdabran
              }"></dxi-item>

            <dxi-item dataField="poslovnicapartnera_pp_id_kupac" editorType="dxSelectBox" [editorOptions]="{
                items: poslovnicePartneraFilter,
                value: 'poslovnicaPartnera_id',
                valueExpr: 'pp_id',
                displayExpr: 'sifrainaziv',
                searchEnabled: 'true',
                searchExpr: ['pp_sifra', 'pp_naziv'],
                onItemClick: poslovnicaPartneraOdabrana
              }"></dxi-item>

            <dxi-item dataField="dokument_do_id_narudzba" editorType="dxSelectBox" [editorOptions]="{ 
                dataSource: neobradeneNarudzbe, 
                value: 'do_id_narudzba', 
                valueExpr: 'do_id', 
                displayExpr: 'do_brojnarudzbe', 
                searchEnabled: 'true', 
                showClearButton: 'true', 
                onItemClick: changeBrojNarudzbe
              }">
            </dxi-item>

            <dxi-item dataField="partner_pa_id_vezni" editorType="dxSelectBox" [editorOptions]="{
                items: prijevoznici,
                value: 'partner_pa_id_vezni',
                valueExpr: 'pa_id',
                displayExpr: 'sifrainaziv',
                searchEnabled: 'true',
                searchExpr: ['pa_sifra', 'pa_naziv']
              }"></dxi-item>

            <dxi-item dataField="pz_registracijavozila"></dxi-item>

            <dxi-item dataField="pz_rednibrojslepera" editorType="dxNumberBox"></dxi-item>

            <dxi-item dataField="crossdock_id" editorType="dxSelectBox" [editorOptions]="{
                dataSource: partneriCrossdock,
                value: 'pa_id',
                valueExpr: 'pa_id',
                displayExpr: 'sifrainaziv',
                searchEnabled: 'true',
                searchExpr: ['pa_sifra', 'pa_naziv']
              }"></dxi-item>
          </dxo-form>
        </dxo-editing>

        <dxi-column dataField="pz_broj" caption="Broj dostavnice" [width]="120" alignment="center"
          [allowEditing]="false"></dxi-column>

        <dxi-column caption="Povezani dokumenti" cellTemplate="cellLink" [width]="100" alignment="center"
          [allowExporting]="false">
          <div *dxTemplate="let data of 'cellLink'">
            <dx-button hint="Povezani dokumenti" icon="link" (onClick)="povezaniDokumenti(data)"></dx-button>
          </div>
        </dxi-column>

        <dxi-column dataField="pz_datum" dataType="date" caption="Datum" [width]="105" alignment="left"></dxi-column>

        <dxi-column dataField="poslovnica_po_id" caption="Skladište otpreme Pekar" [visible]="false"></dxi-column>

        <dxi-column dataField="po_naziv" caption="Skladište otpreme" [minWidth]="240"></dxi-column>

        <dxi-column dataField="pa_naziv" caption="Partner" [minWidth]="180"></dxi-column>

        <!-- "Skladište partnera" -->
        <dxi-column dataField="poslovnicapartnera_pp_id" caption="Skladište otpreme Pekar Tomo"
          [visible]="false"></dxi-column>

        <dxi-column dataField="pp_naziv" caption="Skladište partnera" [minWidth]="180"></dxi-column>

        <dxi-column dataField="partner_pa_id_kupac" caption="Kupac (ako postoji)" [visible]="false"></dxi-column>

        <dxi-column dataField="pa_naziv_kupac" caption="Kupac"></dxi-column>

        <dxi-column dataField="poslovnicapartnera_pp_id_kupac" caption="Poslovnica kupca"
          [visible]="false"></dxi-column>

        <dxi-column dataField="pp_naziv_kupac" caption="Poslovnica kupca"></dxi-column>

        <dxi-column dataField="dokument_do_id_narudzba" caption="Broj narudžbe" [visible]="false"></dxi-column>

        <dxi-column dataField="do_brojnarudzbe" caption="Broj narudžbe"></dxi-column>

        <dxi-column dataField="name" caption="Kreirao"></dxi-column>

        <dxi-column dataField="pz_danisat" dataType="datetime" caption="Datum i vrijeme kreiranja" [width]="130"
          alignment="left"></dxi-column>

        <dxi-column dataField="partner_pa_id_vezni" caption="Prijevoznik" [visible]="false"></dxi-column>

        <dxi-column dataField="prijevoznik" caption="Prijevoznik" [minWidth]="180"></dxi-column>

        <dxi-column dataField="pz_registracijavozila" caption="Registracija vozila" [width]="125"></dxi-column>

        <dxi-column dataField="pz_rednibrojslepera" caption="Broj šlepera" [width]="95" alignment="center"></dxi-column>

        <dxi-column dataField="brojpaleta" caption="Broj paleta" [width]="70" alignment="center"
          [allowFiltering]="false"></dxi-column>

        <dxi-column dataField="pz_vrijemeutovara" caption="Vrijeme utovara" [width]="90"></dxi-column>

        <dxi-column dataField="crossdock_id" caption="Cross-dock skladište" [visible]="false"></dxi-column>

        <dxi-column dataField="crossdock_naziv" caption="Cross-dock skladište" [width]="200"></dxi-column>

        <dxi-column dataField="pz_status" caption="Status" [width]="100" alignment="center"></dxi-column>

        <dxi-column dataField="pz_ediposlana" caption="EDI" [width]="90" alignment="center">
          <dxo-lookup [dataSource]="prikazi" displayExpr="pr_naziv" valueExpr="idprikaz">
          </dxo-lookup>
        </dxi-column>

        <dxi-column dataField="pz_datumediposlano" dataType="datetime" caption="Datum i vrijeme slanja" [width]="130"
          alignment="left"></dxi-column>

        <dxi-column dataField="pz_potvrdaprimitka" caption="Potvrda primitka" [width]="150" alignment="center"
          cellTemplate="potvrdaPrimitkaTemplate">
          <dxo-lookup [dataSource]="prikazi" displayExpr="pr_naziv" valueExpr="idprikaz">
          </dxo-lookup>
        </dxi-column>

        <div *dxTemplate="let data of 'potvrdaPrimitkaTemplate'">
          <span *ngIf="data.data.log_opis" style="color: red;"
            title="{{data.data.log_opis}}">{{data.data.log_opis}}</span>
          <span *ngIf="!data.data.log_opis && data.value === 1">DA</span>
          <span *ngIf="!data.data.log_opis && data.value === 0">NE</span>
        </div>

        <dxi-column dataField="pz_potvrdaprimitka_vrijeme" dataType="datetime" caption="Datum i vrijeme primitka"
          [width]="130" alignment="left"></dxi-column>

        <dxi-column cellTemplate="odobri" [fixed]="true" fixedPosition="right" [allowExporting]="false">
          <div *dxTemplate="let data of 'odobri'">
            <div *ngIf="data.data.pz_status !== 'Z'">
              <dx-button [disabled]="disabledOdobri == true || pravaZaTrenutniPogled != 2" text="Odobri"
                (onClick)="odobriDostavnicu(data)">
              </dx-button>
            </div>
            <br />

            <div *ngIf="data.data.pz_status === 'I' || data.data.pz_status === 'U'">
              <dx-button [disabled]="pravaZaTrenutniPogled != 2" text="Dodaj stavke palete"
                (onClick)="addPalletePopup(data)">
              </dx-button>
            </div>

            <div *ngIf="data.data.pz_status === 'Z'">
              <dx-button icon="pdffile" (onClick)="odabirIspisa(data)" [disabled]="pravaZaTrenutniPogled != 2">
              </dx-button>
            </div>
          </div>
        </dxi-column>

        <dxi-column cellTemplate="otpremnicaPdf" caption="Otpremnica PT" alignment="center" [width]="110" [fixed]="true"
          fixedPosition="right" [allowExporting]="false">
          <div *dxTemplate="let data of 'otpremnicaPdf'">
            <div *ngIf="data.data.pa_naziv_kupac && data.data.pz_status === 'Z'">
              <dx-button icon="pdffile" (onClick)="odabirIspisa_PekarTomo(data)"
                [disabled]="pravaZaTrenutniPogled != 2"></dx-button>
            </div>
          </div>
        </dxi-column>

        <dxo-master-detail [enabled]="false" template="detail"></dxo-master-detail>

        <div *dxTemplate="let data of 'potvrdaPrimitkaTemplate'">
          <span *ngIf="data.data.log_opis" style="color: red;"
            title="{{data.data.log_opis}}">{{data.data.log_opis}}</span>
          <span *ngIf="!data.data.log_opis && data.value === 1">DA</span>
          <span *ngIf="!data.data.log_opis && data.value === 0">NE</span>
        </div>

        <div *dxTemplate="let data of 'detail'">
          <p *ngIf="!stavke">Dohvaćanje stavki...</p>
          <p *ngIf="stavke.length === 0">Dostavnica nema stavki!</p>
          <div *ngIf="stavke.length > 0">
            <div class="dostavnicaStavke">
              <dx-data-grid [dataSource]="stavke" [wordWrapEnabled]="true" [showColumnLines]="true"
                keyExpr="idlotpromet" [showBorders]="true" (onRowUpdated)="urediStavku($event)"
                (onRowRemoved)="obrisiStavku($event)" [disabled]="pravaZaTrenutniPogled != 2">
                <dxo-group-panel [visible]="true"></dxo-group-panel>

                <dxo-grouping #expand [autoExpandAll]="true"></dxo-grouping>

                <dxo-editing *ngIf="data.data.pz_status !== 'Z'" mode="cell" [allowUpdating]="true"
                  [allowDeleting]="true"></dxo-editing>

                <dxi-column dataField="ar_sifra" caption="Šifra" [width]="120" [allowEditing]="false"></dxi-column>

                <dxi-column dataField="ar_naziv" caption="Proizvod" [width]="500" [allowEditing]="false"></dxi-column>

                <dxi-column dataField="ar_lot" caption="LOT" [width]="120" [allowEditing]="false"
                  [groupIndex]="0"></dxi-column>

                <dxi-column dataField="pr_izlaz" caption="Količina" [width]="120" [allowEditing]="false"></dxi-column>

                <dxi-column dataField="br_kutija" caption="Broj kutija" [width]="120" alignment="center"
                  [allowEditing]="false"></dxi-column>

                <dxi-column dataField="sscc_broj" caption="SSCC" [width]="220">
                  <dxi-validation-rule type="pattern" pattern="^[0-9]+$"
                    message="Dozvoljeni su samo brojevi"></dxi-validation-rule>
                </dxi-column>

                <dxi-column dataField="lp_sifranarudzbe" caption="Referentni broj" [width]="220"
                  [allowEditing]="false"></dxi-column>

                <dxi-column dataField="lp_vazido" dataType="date" caption="Važi do" [width]="130" alignment="center"
                  [allowEditing]="false">
                </dxi-column>

                <!-- <dxi-column type="buttons" [width]="75">
                  <dxi-button
                    hint="Dodavanje palete"
                    icon="plus"
                    (onClick)="addPalletePopup()"
                  ></dxi-button>
                </dxi-column> -->

                <!-- BUTTON ZA POPUP DODAVANJE PALETA -->
                <!-- <dxi-column>
               
                 <dxi-button
                    icon="plus"
                    hint="Dodavanje palete"
                    stylingMode="outlined"
                    type="success"
                    (onClick)="addPalletePopup()"
                  >
                  </dxi-button>

                  <ng-template cellTemplate let-data="data">
            <dx-button text="Button Text"></dx-button>
        </ng-template>
                  </dxi-column> -->

                <!-- <dxi-column type="buttons" [width]="75">
                  <dxi-button
                    hint="Dodavanje palete"
                    icon="plus"
                    [onClick]="addPalletePopup()"
                  ></dxi-button>
                </dxi-column> -->

                <dxo-summary>
                  <dxi-group-item column="ar_lot" summaryType="count" displayFormat="Ukupno paleta: {0}">
                  </dxi-group-item>
                </dxo-summary>

                <dxi-sort-by-group-summary-info summaryItem="count"></dxi-sort-by-group-summary-info>
              </dx-data-grid>
            </div>
          </div>
        </div>
      </dx-data-grid>
    </div>
  </div>
</div>

<!-- (onRowUpdated)="urediZaglavlje($event)" -->
<!-- POPUP ZA DODAVANJE PALETA -->
<dx-popup [width]="1000" [height]="'auto'" [showTitle]="true" title="Ručno upisivanje palete" [dragEnabled]="false"
  [showCloseButton]="true" [(visible)]="popupAddPalleteVisible" [closeOnOutsideClick]="false">
  <div class="popup-form-wrapper">
    <div class="floating-placeholder">
      <dx-select-box [dataSource]="sviProizvodi" displayExpr="sifraNaziv" [(value)]="odabraniProizvod"
        placeholder="Proizvod" (onValueChanged)="onChangeProizvodId($event)" [searchEnabled]="true"
        [showClearButton]="true" required></dx-select-box>
    </div>

    <div class="floating-placeholder">
      <dx-select-box [dataSource]="sviLotoviDataSource" displayExpr="lotBroj" valueExpr="rnalozi_nl_id"
        [(value)]="radniNalog_id" placeholder="LOT broj" (onValueChanged)="onChangeLot($event)" [searchEnabled]="true"
        [showClearButton]="true" itemTemplate="customItem" required>
        <div *dxTemplate="let item of 'customItem'">
          <div [ngClass]="{'rok-istekao': item.rokIstekao}">
            {{ item.lotBroj }}
          </div>
        </div>
      </dx-select-box>
    </div>

    <!-- <div class="floating-placeholder">
      <dx-select-box
        [dataSource]="sviLotovi"
        displayExpr="lotBroj"
        valueExpr="id"
        [(value)]="lotBroj"
        placeholder="Lot broj"
        [searchEnabled]="true"
        [showClearButton]="true"
        (onValueChanged)="onChangeLot($event)"
        required
      ></dx-select-box>
    </div> -->

    <!-- <div class="floating-placeholder">
      <dx-text-box
        placeholder="LOT broj"
        [value]="lotBroj"
        (onValueChanged)="onChangeLot($event)"
        [showClearButton]="true"
        required
      ></dx-text-box>
    </div> -->

    <div class="floating-placeholder">
      <dx-text-box placeholder="Broj kutija" [value]="brojKutija" [showClearButton]="true"
        (onValueChanged)="onChangeKutije($event)" required></dx-text-box>
    </div>

    <div class="floating-placeholder">
      <dx-text-box placeholder="SSCC kod" [value]="sscc" [showClearButton]="true" [maxLength]="20"
        (onValueChanged)="onChangeSscc($event)" (onKeyPress)="onKeyPressSscc($event)"></dx-text-box>
    </div>

    <div class="floating-placeholder">
      <dx-text-box placeholder="Broj istih paleta" [value]="brojIstihPaleta" [showClearButton]="true"
        (onValueChanged)="onChangeBrojIstih($event)"></dx-text-box>
    </div>

    <dx-button [width]="'auto'" [height]="'auto'" class="dodajButton" stylingMode="outlined" type="success" text="Dodaj"
      [disabled]="!idProizvoda || !radniNalog_id || !lotBroj || !brojKutija || disable_ssccBroj || obavezan_sscc"
      (onClick)="dodajPaletu()">
    </dx-button>

    <!-- <div class="floating-placeholder">
    <dx-select-box 
        [dataSource]="admin"
        displayExpr="naziv"
        valueExpr="id"
        placeholder="Admin"
        [value]="adminStatus === 'Da' ? 1 : 0"
        (onValueChanged)="onChangeAdmin($event)">
    </dx-select-box>
  </div> -->
    <!-- <div class="floating-placeholder">
    <dx-select-box 
        [dataSource]="vrsta"
        displayExpr="naziv"
        valueExpr="id"
        placeholder="Vrsta"
        [value]="vrstaStatus"
        (onValueChanged)="onChangeVrsta($event)">
    </dx-select-box>
  </div> -->

    <!-- <div class="floating-placeholder">
      <dx-select-box 
          [dataSource]="radnaMjesta"
          displayExpr="naziv"
          valueExpr="id"
          placeholder="Radno mjesto"
          [value]="radnoMjesto"
          (onValueChanged)="onChangeRadnoMjesto($event)">
      </dx-select-box>
  </div> -->
    <!-- <div class="floating-placeholder">
      <dx-select-box 
          [dataSource]="partneri"
          displayExpr="naziv"
          valueExpr="id"
          placeholder="Partner"
          [value]="partnerId"
          [searchEnabled]="true"
          [searchExpr]="'naziv'"
          (onValueChanged)="onChangePartner($event)">
      </dx-select-box>
  </div> -->
    <!-- <div class="floating-placeholder">
      <dx-select-box 
          [dataSource]="poslovnice"
          displayExpr="naziv"
          valueExpr="id"
          placeholder="Poslovnica"
          [value]="poslovnicaId"
          [searchEnabled]="true"
          [searchExpr]="'naziv'"
          (onValueChanged)="onChangePoslovnica($event)">
      </dx-select-box>
  </div> -->
  </div>

  <!-- <div *dxTemplate="let data of 'naslovTablice'"></div>
  <dx-data-grid
    [dataSource]="stavkePalete"
    [showBorders]="false"
    [wordWrapEnabled]="true"
  >
    <dxi-column
      dataField="stavkePaleta"
      caption="Stavke"
      cellTemplate="templateStavke"
    ></dxi-column>
    <div *dxTemplate="let data of 'templateStavke'">
      <dx-check-box displayExpr="sgr_naziv" [value]="data.data.stavkePaleta">
      </dx-check-box>
    </div>
    <dxi-column dataField="sgr_naziv" caption="Naziv grupe"></dxi-column>
  </dx-data-grid> -->
</dx-popup>


<dx-popup [title]="naslov" [showTitle]="true" [width]="1000" [height]="'auto'" [closeOnOutsideClick]="false"
  [showCloseButton]="true" [(visible)]="povezaniDokumentiPopup" [position]="{ my: 'center', at: 'center', of: window }">

  <dx-data-grid id="tablicaPovezaniDokumenti" [dataSource]="povezani_dokumenti" [showColumnLines]="true"
    [wordWrapEnabled]="true" [showBorders]="false">
    <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>
    <dxi-column dataField="pz_broj" caption="Broj" [width]="100" alignment="right">
    </dxi-column>
    <dxi-column dataField="DV_NAZIV" caption="Vrsta" alignment="center">
    </dxi-column>
    <dxi-column dataField="pz_datum" dataType="date" caption="Datum" [width]="130" alignment="center">
    </dxi-column>
    <dxi-column dataField="fi_naziv" caption="Firma">
    </dxi-column>
    <dxi-column dataField="po_naziv" caption="Naziv skladišta">
    </dxi-column>
  </dx-data-grid>
  <br>
  <dxi-item class="btn_group">
    <dx-button stylingMode="contained" [height]="40" [width]="120" type="success"
      (onClick)="uredu()">UREDU</dx-button><br><br>
  </dxi-item>
</dx-popup>